import React from "react";

import { DocScanEvidenceTab } from "pages/admin/verifications/components/automations/DocScanEvidenceTab";
import { EvidenceDrawer, EvidenceTab, EvidenceTabKey } from "pages/admin/verifications/components/automations/EvidenceDrawer";
import { RemoteSensingEvidenceTab } from "pages/admin/verifications/components/automations/RemoteSensingEvidenceTab";
import { CoverCropChip } from "pages/admin/verifications/utils/coverCropChips";

/** The field and year whose evidence the admin clicked, and the evidence each tab shows. */
export type FieldEvidenceSelection = {
  fieldId: string;
  fieldName: string;
  year: number;
  defaultTabKey: EvidenceTabKey;
  docScanFieldId?: string;
  /** Start of the field-year's cover crop observation window, when it has a detection. */
  coverCropWindowStart?: string | null;
  /** The detection's chip on the crop timeline, when it made one. */
  coverCropChip?: CoverCropChip | null;
};

type FieldEvidenceDrawerProps = {
  farmId: string;
  selection: FieldEvidenceSelection | null;
  isOpen: boolean;
  onClose: () => void;
};

const getEvidenceTabs = (
  farmId: string,
  { docScanFieldId, fieldId, fieldName, year, coverCropWindowStart, coverCropChip }: FieldEvidenceSelection
): EvidenceTab[] => [
  ...(docScanFieldId
    ? [
        {
          key: "docScan" as const,
          label: "Doc scanning",
          iconName: "tabler/file-check",
          content: <DocScanEvidenceTab key={docScanFieldId} farmId={farmId} scanFieldId={docScanFieldId} />,
        },
      ]
    : []),
  {
    key: "remoteSensing",
    label: "Remote sensing",
    iconName: "tabler/satellite",
    content: (
      <RemoteSensingEvidenceTab
        key={`${fieldId}-${year}`}
        farmId={farmId}
        fieldId={fieldId}
        fieldName={fieldName}
        seasonYear={year}
        coverCropWindowStart={coverCropWindowStart}
        coverCropChip={coverCropChip}
      />
    ),
  },
];

export const FieldEvidenceDrawer = ({ farmId, selection, isOpen, onClose }: FieldEvidenceDrawerProps) =>
  selection && (
    <EvidenceDrawer
      title={`${selection.fieldName} · ${selection.year}`}
      tabs={getEvidenceTabs(farmId, selection)}
      defaultTabKey={selection.defaultTabKey}
      isOpen={isOpen}
      onClose={onClose}
    />
  );
